
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();
import { Etap } from "./Etap"
import  EtapVue  from "./Etap.vue"
import { Debouncer } from "@/lib/Debouncer"
import  ButtonVue from "@/lib/Button.vue"; 
import FinderInlineVue from "@/finder/FinderInline.vue";
import  WykrojnikParamsVue from "../wykrojniki/params/WykrojnikParamsVue.vue"
import  WykrojnikiVue from "../wykrojniki/costdetail/WykrojnikiVue.vue"
import IdxVue from "../idx/IdxVue.vue";

import { WykrojnikSvc } from "../wykrojniki/WykrojnikSvc"
import { TreeSvc } from "./TreeSvc";
import { ITree } from "./ITree";
import { WykrojnikiCostSvc } from "@/wykrojniki/costdetail/WykrojnikiCostSvc";
import Store from "@/store/Store"; 
import { MasterData } from "@/store/MasterData"; 
import { IUser } from "@/../../server/src/user/IUser";

import { ILbl } from "@/lbl/ILbl";
import { LblSvc } from "@/lbl/LblSvc";
import { lbl_api } from "@/lbl/ILblSvc";

import { Finder, IFinder } from "@/finder/IFinder";
import { IOpMapParams } from "server/src/tree/mapper/op/IOpMapParams";
import { IOpEtap, IOpEtapValidation, IOpEtapyValidations,IOpOperacja, IOpParent } from "@/../server/src/tree/mapper/op/IOp";
import { OpParent } from "../../server/src/tree/mapper/op/OpParent";
import { IPrj } from "@/prj/IPrj";
import OpOperacjeVue from "./OpOperacje.vue"
import DbgVue from "../Dbg.vue"
import { ObjEvents } from "@/../server/src/mqtt/ObjEvents";
import { EmailExtractor } from "@/lbl/EmailExtractor";
import { Dims } from "../../server/src/tree/Dims";
import  LblVue from "../lbl/Lbl.vue"

import { tree_api } from "./ITreeSvc";





type TypEtapu = {
  etap_nazwa:string;
  etap_typ:string;
}

let cc= { EtapVue,  ButtonVue, FinderInlineVue, WykrojnikParamsVue, WykrojnikiVue, IdxVue,OpOperacjeVue, DbgVue, LblVue}

//console.log(cc)

@Component({ components: cc })

export default class TreeVue extends Vue {
 
  @Prop(Object) tree_prop:any;
  @Prop(String) tree_id!: string;
  @Prop(String) prj_id!:  string;
  id:string|undefined=""
  tree!:ITree;
  prj:IPrj|undefined
  lbl:ILbl|undefined=undefined;
  parent: IOpParent | undefined
  masterData: MasterData|undefined;
  user:IUser=bus.get_user();
  operacje:any[]=[]
  etapy:IOpEtap[]=[]
  generating_operacje_from_tree:number=0;
  etapy_validations: IOpEtapyValidations ={}
  etapy_validations_key:number=0;
  show_przygotuj_do_akceptacji=false
  lblSvc=new LblSvc()
  tabs:any[]= ['Technologia', 'Etykieta ERP']
  activeTab= 'Technologia'
  technologie_projektu:IFinder[]=[]

  colors!:any[] 


  last_changed_by?: string
  debounced:any
  test_data_key:number=0;

  global_key:number=0;
  tree_key:number = 0
  operacje_key:number=0
  idx_key:number=0
  lbl_key:number=0

  created() {
    
    //bus.register('create_new_tree', this.create_new_tree)
    //bus.register('etap_added', this.etap_added)
    //bus.register('etap_deleted', this.etap_deleted)
  }

  inc(which:string, proc:string) { 
    console.log("******  ****** ******* ********* inc(): "+which+"proc: "+proc); 
    if (which==="global") {
      this.global_key++ 
    }
    if (which==="tree") {
       if (this.tree)  this.tree_key++ 
       else this.tree_key = 0;
    }
    if (which==="operacje") {
      if (this.operacje) this.operacje_key++
      else this.operacje_key = 0;
    }
    if (which==="idx") {
      this.idx_key++
    }
    if (which==="lbl") {
      if (this.lbl) this.lbl_key++
      else this.lbl_key = 0;
    }
  }
  
  async refresh(partial_update?:boolean) {

    console.log("refresh using id", this.tree_id);

    if (!this.tree_id) return;
    // this.id = this.$route.params.tree_id
    const t:ITree|undefined = await new TreeSvc().find_by_id( this.tree_id );


    if (!t) return
    this.tree = t;

    // teraz jest w fill_and_validate(tree) //TreeServer
    this.etapy_validations = this.fill_etapy_validation(this.tree)
    //this.etapy_validations = (<any>t).etapy_validations
    //if (!this.etapy_validations) this.etapy_validations = this.fill_etapy_validation(this.tree)
    this.etapy_validations_key++

    this.inc("idx", "refresh 1")
    this.inc("tree", "refresh 1")
    this.id=this.tree._id;

    if (t.parent_id && t.parent_type=="prj") {
        const p:IPrj|undefined = await new TreeSvc().find_prj_by_id( t.parent_id );
        if (p && p._id) this.prj = p;
        if (!p) return;
    }
    
        
    let lbl:ILbl|undefined=undefined
    this.inc("lbl", "refresh 1")


    if ((<any>this.tree).lbl_id ) {
      lbl=await new LblSvc().find_by_id((<any>this.tree).lbl_id)
    }
    if (lbl && lbl._id) {
      console.log("lbl found "+lbl._id)
      this.lbl=lbl
      console.log("lbl found "+lbl)
      this.lbl=lbl

      if (!this.lbl.oferta_tree_finder) this.lbl.oferta_tree_finder=new Finder();
      const techs:any= await bus.call(tree_api.find_trees_short,{prj_id:this.tree.parent_id});
      if (techs && techs.length) {
        this.technologie_projektu= []
        for (let t of techs) {
          const f=new Finder()
          f._id = t._id
          const nr=t.nr? t.nr:"??"
          const idn=t.idn? t.idn:"??"
          const wykr=t.nr_wykrojnika? t.nr_wykrojnika:"??"
          const x=t.x?t.x:""
          const y=t.y?t.y:""
          f.text = nr+":"+idn+" wykr:"+wykr+""
          //if (x && y) f.text+=" wymiary:"+x+"x"+y
          
          if (f._id && nr) {
          this.technologie_projektu.push(f)
          }
        }


      }

      let l=await this.lblSvc.get_call_results(this.lbl)
      if (l && l._id) {
        console.log("get_call_results OK")
        console.log(l)
        this.lbl=l
      }
      console.log(this.lbl)

      
    }

    const wykrojnik_sel = await new WykrojnikSvc().get_selected_wykrojnik_for_tree(this.tree_id)
    const tree=this.tree

    const msgs = Dims.set_dims_to_tree(this.lbl, tree, wykrojnik_sel, undefined)    


    if (wykrojnik_sel) {
      bus.fire("hilight_wykrojnik",wykrojnik_sel)
    }

  
    if (this.lbl)     this.inc("lbl", "refresh 2")
    
   
    if (this.prj && this.tree) {
      this.refresh_parent()
      if (!partial_update)     this.inc("operacje", "refresh 2")
    }
    console.log("refreshed tree", tree)

    if (!partial_update)      this.inc("global", "refresh 2")
  }


  refresh_parent() {
    
      const parent:OpParent = new OpParent()
      parent.init_from_prj(this.prj)
      parent.init_from_tree(this.tree)
      
      parent.init_from_lbl(this.lbl)
      this.parent = parent
    

  }

  async mounted() {

    this.masterData = (await new Store().getStore()).masterData;
    this.user=bus.get_user();

    await this.refresh();


    this.debounced = Debouncer.debounce(await (this._chg.bind(this)), 300).bind(this);
    bus.register(ObjEvents.status_changed, this.status_changed);
    bus.register(ObjEvents.event_insert, this.message_received);
    bus.register(ObjEvents.event_update, this.message_received);
    bus.register(ObjEvents.event_delete, this.message_received);
    bus.register('wybierz_technologie_z_findera', this.wybierz_technologie_z_findera)


  }

  

  beforeDestroy() {
    bus.remove(ObjEvents.status_changed, this.status_changed);
    bus.remove(ObjEvents.event_insert, this.message_received);
    bus.remove(ObjEvents.event_update, this.message_received);
    bus.remove(ObjEvents.event_delete, this.message_received);
    bus.remove('wybierz_technologie_z_findera', this.wybierz_technologie_z_findera)

  }


  message_received(e:any) {
    const obj = e.detail;
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>received mqtt",obj)
    
    if (!this?.tree._id) return;
    if (!(obj.type=="op")) return;
    if (!obj.parent?.tree_id == this.tree._id) return;

    let changes_by_myself = true
    if (obj.changed_by!=bus.get_user().data_username) {
        changes_by_myself = false
        if (this.last_changed_by!=obj.changed_by) {
          this.last_changed_by=obj.changed_by
          //alert("Użytkownik "+obj.changed_by+" właśnie wprowadził tu zmiany. Ostatnia zmiana: "+obj.changed_date)
        }
    }

    let partial_update = true
    if (!changes_by_myself) {
      if (obj.changed_by!=bus.get_user().data_username) partial_update = false;
      if (obj.touch=="C")                               partial_update = false;
      if (obj.touch=="D")                               partial_update = false;
    }

    if (obj.touch=="C") this.scroll(obj._id)

    console.log("********************** TreeVue message_received. Partial update=", partial_update, obj.changed_by, bus.get_user().data_username)
    
    //this.refresh(partial_update)
  }


  scroll(_id:string) {
    if (!_id) return;
    const lastEditedItemId = _id
    if (lastEditedItemId) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(lastEditedItemId);
          if (element) {
            // Define the offset from the top of the viewport
            const offset = 500; // Change this value to your desired offset

            // Calculate the desired scroll position
            const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
            const scrollPosition = elementTop - offset;

            // Scroll to the desired position
            window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
          }
        }, 1000); // Delay scrolling by 1 second
      });
    }

  }
   async status_changed(e:any) {

      const obj = e.detail;
      if (obj.type!="lbl") return;
      if (!this.lbl) return;
      if (obj._id!=this.lbl._id) return;
      //alert("Tree: Etykieta zmieniła status na "+obj.status)
      this.operacje_key++
      await this.refresh()
  }

  scrollDown() {
    const el = this.$refs.scrollDown;

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      //(<any>el).scrollIntoView({behavior: 'smooth'});
    }
  }

  async add_new_etap(t:TypEtapu) {
    if (!this.tree) return;

    const etap:Etap = { etap_typ: t.etap_typ, predkosc:0, nazwa: t.etap_nazwa, kalk_id:this.tree.kalk_id, grupa_maszyn:"", list_order:0, etap_id:0, technologie:[], rodzaj_farby:"", rodzaj_lakieru:"",kolory_studio:[], etap_op_id: undefined}
    this.tree.etapy.push(etap)
    this.inc("global", "add_new_etap")
    await this.chg()
    this.scrollDown()
  }


  async del_etap(etap: Etap) {
    let id = etap.etap_id;

    for (let i = this.tree.etapy.length-1; i >=0; i--) {
      if (this.tree.etapy[i].etap_id == id) {
        this.tree.etapy.splice(i, 1);
      }
    }
    this.inc("global", "del_etap")
    await this.chg()
  }

 async grupa_maszyn_changed() {
     console.log("grupa_maszyn_changed")
     //if (!this.lbl) return;
     await this.chg()
  }

  async rodzaj_farby_changed() {
    
    //console.log("rodzaj_farby_changed",this.tree)
    //if (!this.lbl) return;
    await this.chg()
  }

 async rodzaj_lakieru_changed() {
    //console.log("rodzaj_lakieru_changed",this.tree)
    //if (!this.lbl) return;
     await this.chg()
  }

  async etap_changed() {
    console.log("etap_changed")

    await this.chg()
  }

  async chg() {
    console.log("chg")

    if (!this.debounced) return;
    Bus.lock()
    await this.debounced();


  }

  async rezerwuj_zlecenie(tree_id:any, nakład_K_ist:number) {
    const tt=(<any>this.tree)
    tt.test_data=undefined
    const ret:any = await new WykrojnikiCostSvc().zlecenia_kontrolne_rezerwuj(tree_id, (<any>this.tree).nakład_K_ist)
    if (ret.nr_zlecenia_ist) {
      this.tree.nr_zlecenia_ist = ret.nr_zlecenia_ist
      this.tree.grupa_maszyn_ist = ret.grupa_maszyn_ist
      tt.test_data=ret.test_data
      this.test_data_key++;
      this.chg()
    }
  }

  async _chg() {
    

    const t:ITree|undefined =await new TreeSvc().fill_and_validate( this.tree );
    console.log("_chg calling fill_and_validate ", t?.idn )

    Bus.unlock()
    if (!t) return;

    //console.log(t.stat.surowce)
    this.tree=t;
    bus.fire('tree_modified',this.tree)
    this.inc("global","_chg")
   
  }


  async get_sekwencja() {

      let changed=0;
      console.log(this.tree)
      if (!this.tree) return;
      console.log(this.lbl)
      if (!this.lbl) return;


      this.lbl.type = "lbl"   

      this.lbl.flekso  =0;
      this.lbl.cyfra   =0;
      this.lbl.hybryda =0;

      for (let i=0;i<this.tree.etapy.length;i++) {
        let e=this.tree.etapy[i]

        if (e.etap_typ=="ETAP_START") {
           if (e.technologie.length>0) {
            let t=e.technologie[0]
            console.log(e)
            if (t.komponent_finder) {
              this.lbl.surowiec_podst_finder = t.komponent_finder
            }
            //if (t.komponent_finder) alert("komponent finder "+ t.komponent_finder._id)
            //if (t.komponent_farba_finder) alert("komponent farba finder "+t.komponent_farba_finder._id)
           }
        }
        if (e.etap_typ=="ETAP_CYFRA") {
            this.lbl.cyfra = 1
        }
        if (e.etap_typ=="ETAP_FLEKSO") {
            if (e.grupa_maszyn=="M") this.lbl.hybryda = 1
            else this.lbl.flekso = 1
        }
      }


      if (this.lbl.flekso + this.lbl.cyfra + this.lbl.hybryda == 0) { 
        alert("Dodaj ETAP_FLEKSO (opcjonalnie z kolorami INKJET) lub ETAP_CYFRA.")
        return;
      } 


      if (!this.lbl.surowiec_podst_finder) {
        alert("Dodaj (co najmniej 1) komponent w ETAP_START.")
        return;
      }

      if (!this.lbl.surowiec_podst_finder._id) {
        alert("Dodaj (co najmniej 1) komponent w ETAP_START!")
        return;
      }
      
      //alert("lbl.file_path"+this.lbl.file_path+"lbl.flekso="+this.lbl.flekso+ " surowiec="+this.lbl.surowiec_podst_finder.text)
      

      const ret = await bus.api(lbl_api.start_flow_sekwencja, { lbl: this.lbl  });
      console.log(ret)
      if (ret)  changed++;
      
      if (changed>0) {
        alert("Plik skierowany do opisania sekwencji kolorów")
      } else {
        alert("Nie udało się skierować plików do opisania sekwencji kolorów.")
      }

  }

  is_thermal(surowiec_podst_finder: IFinder): number {
        let data = surowiec_podst_finder.data
        if (data.data_komponent_nazwa.indexOf("THERMAL") > -1) return 1;
        return 0;
    }

    is_iml(surowiec_podst_finder: IFinder): number {
        let data = surowiec_podst_finder.data
        if (data.data_komponent_typ == 'IML' || data.data_komponent_typ == 'BML') return 1;
        return 0;
    }

  async create_map_params_from_tree(tree:ITree):Promise<IOpMapParams> {


    let file_path_128_lbl=""
    let file_url_lbl=""
    if (this.lbl) {
       file_path_128_lbl=this.lbl.file_path_128
       file_url_lbl=this.lbl.file_url
    }

    const parent:OpParent = new OpParent()
    parent.init_from_prj(this.prj)
    parent.init_from_tree(this.tree)
    parent.init_from_lbl(this.lbl)

    const wykrojnik_selected = await new WykrojnikSvc().get_selected_wykrojnik_for_tree(this.tree_id)
    parent.init_from_wykrojnik(wykrojnik_selected)
  
    this.parent = parent


    let peel_off=0;
    let rodzaj_farby=""
    let rodzaj_lakieru=""
    let flekso=0
    let cyfra=0
    let surowiec_podst_finder:IFinder|undefined = undefined

    for (let i=0;i<tree.etapy.length;i++) {
        let e=tree.etapy[i]

        if (e.etap_typ=="ETAP_START") {
           if (e.technologie.length>0) {
            let t=e.technologie[0]
            if (t.komponent_finder) {
              surowiec_podst_finder = t.komponent_finder
            }
            for(let j=0;j<e.technologie.length;j++) {
              let t=e.technologie[j]
              if (t.typ.indexOf("peel off")>-1) {
                peel_off=1
              }
            }
           }
        }
        if (e.etap_typ=="ETAP_CYFRA") {
            cyfra=1;
        }
        if (e.etap_typ=="ETAP_FLEKSO") {
            flekso=1;
        }

        if (e.etap_typ=="ETAP_FLEKSO" && !rodzaj_farby && !rodzaj_lakieru) {
            if (e.rodzaj_farby) rodzaj_farby=e.rodzaj_farby
            if (e.rodzaj_lakieru) rodzaj_lakieru=e.rodzaj_lakieru
        }
    }

    let thermal:number = 0
    if (surowiec_podst_finder && surowiec_podst_finder.data && surowiec_podst_finder.data.data_komponent_nazwa && surowiec_podst_finder.data.data_komponent_nazwa.indexOf("THERMAL") > -1) thermal=1;
    
    let iml:number = 0
    if (surowiec_podst_finder && surowiec_podst_finder.data && ((surowiec_podst_finder.data.data_komponent_typ == 'IML' || surowiec_podst_finder.data.data_komponent_typ == 'BML'))) iml=1;

    let surowiec_podst_id:string=""
    if (surowiec_podst_finder && surowiec_podst_finder._id) surowiec_podst_id=surowiec_podst_finder._id;

    let komponent_pierwsza_warstwa = ""
    if (thermal) komponent_pierwsza_warstwa = "THERMAL"
    else if (iml) komponent_pierwsza_warstwa = "IML"
    else if (peel_off) komponent_pierwsza_warstwa = "PEEL_OFF"


    let etapy_params=this.create_etapy_params(tree)


    const map_params:IOpMapParams={surowiec_podst_id:surowiec_podst_id, komponent_thermal: thermal, komponent_iml:iml, komponent_suszenie:rodzaj_farby, lakier_suszenie: rodzaj_lakieru,
      komponent_pierwsza_warstwa: komponent_pierwsza_warstwa, produkt_peel_off:peel_off, parent:parent, flekso:flekso, cyfra:cyfra, etapy_params:etapy_params, 
      file_path_128_lbl: file_path_128_lbl,
      file_url_lbl:file_url_lbl 
      }

    return map_params;
  }


  verify_map_params(map_params:IOpMapParams):IOpMapParams|undefined {

    let s=""
    if (!map_params.surowiec_podst_id) {
        s+="Wybierz surowiec podstawowy w etapie start. "
    }

    if (map_params.flekso) {
      if (!map_params.komponent_suszenie) {
          s+="Wybierz rodzaj farby dla etapów flekso. "
      }

      if (!map_params.lakier_suszenie) {
          s+="Wybierz rodzaj lakieru dla etapów flekso. "
      }
    }

    if (map_params.flekso==0 && map_params.cyfra==0) {
          s+="Dodaj ETAP_FLEKSO lub ETAP_CYFRA. "
    }


    if (s.length) {
        return undefined;
    }
    return map_params;
  }

  create_etapy_params(tree:ITree): IOpEtap[] {
    let etapy_params:any[]=[]

    for (let i=0;i<tree.etapy.length;i++) {
        let e=tree.etapy[i]
        etapy_params.push({etap_typ: e.etap_typ, grupa_maszyn: e.grupa_maszyn, rodzaj_farby: "UV", rodzaj_lakieru: "UV" })
    }
    //alert(JSON.stringify(etapy_params))
  
    return etapy_params;
  }



  private fill_etapy_validation(t:ITree):IOpEtapyValidations {
      
      const eparams:IOpEtapyValidations={}
      for (let i=0;i<t.etapy.length;i++) {
          
          const e:any=t.etapy[i]

          const ep:IOpEtapValidation  = {
              etap_id:e.etap_op_id,
              grupa_maszyn_valid: e.grupa_maszyn,
              grupy_maszyn_valid: e.grupy_maszyn,
              odpad: e.stat ? e.stat.odpad:0,
              odpad_zmiana: e.stat ?e.stat.odpad_zmiana:0,
              zeby:e.stat ?e.stat.zeby: 0,
              predkosc:e.stat ?e.stat.predkosc:0
          }
      
          eparams[ep.etap_id] = ep
          console.log('eparams',e.grupa_maszyn, ep.etap_id, ep)
      }

      return eparams;
  }

  async idx_changed() {
    this.inc("global", "idx_changed")
    this.inc("operacje", "idx_changed")
  }

  async operacje_changed(operacje: IOpOperacja[]) {
    console.log("####################################TreeVue operacje_changed")
    this.refresh_parent()
    if (!this.parent) return;

    const tree:ITree|undefined = await new TreeSvc().map_operacje_to_tree(operacje, this.parent, this.tree.idn, this.tree.nr, this.tree.x, this.tree.y);
    console.log(this.tree.idn)
    console.log(tree?.idn)
    console.log("emit operacje_changed")
    if (!tree || !tree._id) {
      console.log('map_operacje_to_tree: empty tree')
      return;
    }


    for (let i=0;i<tree?.etapy.length;i++) {
        const e= tree?.etapy[i]
        console.log('grupa maszyn etapu:',e.etap_typ, e.grupa_maszyn)
    }

    if (this.generating_operacje_from_tree) {
      alert('operacje_changed loop detected. BREAK')
      return;
    }

    console.log('operacje_changed START')
    this.tree = tree
    console.log('operacje_changed tree OK')
    bus.fire('tree_modified',this.tree)
    this.inc("tree", "operacje_changed")
    
    // teraz jest w fill_and_validate(tree) //TreeServer
    this.etapy_validations = this.fill_etapy_validation(this.tree)
    //this.etapy_validations = (<any>tree).etapy_validations
    this.etapy_validations_key++
    this.inc("idx", "operacje_changed")
  }

/*
  async map_colors_to_tree(tree:ITree, lbl: ILbl) {

    if (!lbl) { 
      alert("brak etykiety")
      return;
    }
    if (!lbl._id) { 
      alert("brak id etykiety")
      return;
    }
    if (!lbl.colors || lbl.colors.length<=0) {
      alert("brak kolorów")
      return;
    }
    
    if (!tree) {
      alert("brak technologii")
      return;
    }

    if (!tree._id) {
      alert("brak id technologii")
      return;
    }

    this.operacje_key=0
    this.operacje = <any> await new TreeSvc().update_tree_from_colors(tree);
    console.log("operacje:",this.operacje)
    if (this.operacje) {
      this.operacje_key++
      await this.operacje_changed(this.operacje)
    }
  }
  */


  async map_tree_to_operacje(tree: ITree, parent:IOpParent) {

    if (!tree) return;
    if (!parent) return;
    
    let map_params:IOpMapParams|undefined = await this.create_map_params_from_tree(tree)
    if (!map_params) return;

    let operacje_new:IOpOperacja[] = await new TreeSvc().map_tree_to_operacje(tree, parent);
    if (!operacje_new) return;


    
    this.generating_operacje_from_tree=1
    this.operacje = operacje_new
    this.inc("operacje", "map_tree_to_operacje")
    this.generating_operacje_from_tree=0
  }

  // dodatkowe cechy do flow akceptacja
  async start_flow_akceptacja() {

      
      try {

        let lbl=null
        if ((<any>this.tree).lbl_id ) {
          lbl=await new LblSvc().find_by_id((<any>this.tree).lbl_id)
        }
        if (!lbl) return;
        this.lbl=lbl

        if (!this.lbl) return;

        await new EmailExtractor().use_groups_from_clipboard(this.lbl.groups, this.lbl)
        alert("TEXT:"+this.lbl?.email_do_akceptacji_text+" ARR "+JSON.stringify(this.lbl?.email_do_akceptacji))

        if (!confirm("Czy rozpocząć flow akceptacja?")) return;
    
        const lbl1 =  await this.lblSvc.update(this.lbl)
        if (lbl1 && lbl1._id) {
          this.lbl = lbl1
        }

        if (!this.operacje) return;

        console.log(this.lbl)
        const ret = await bus.api(lbl_api.start_flow_akceptacja, { lbl: this.lbl, operacje: this.operacje  });
        console.log(ret)
        alert("Etykieta skierowana do Flow Akceptacja")
      } catch (err) {
        console.log(err)
        let e:String="Brakuje jeszcze danych aby rozpocząć akceptację.\n"
        e+="Skompletuj dane etykiety:\n"
        for (let i=0;i<(<any>err).messages.length;i++) {
          e+=(<any>err).messages[i]+"\n"
        }
        alert(e)
    } 
  }


  async cofnij_akceptacje() {
    const l=this.lbl
    if (!l) return;
    if (confirm("Na pewno cofnąć akceptację  etykiety?")) {
      l.status = "SEKWENCJA_OK";
      const lbl = await this.lblSvc.set_status(l);
      alert("Status zmieniony na SEKWENCJA_OK")
      if (lbl && lbl._id) this.lbl=lbl;
      this.inc("global", "cofnij_akceptacje")

    }
  }

  async lbl_changed() {
      this.inc("lbl", "lbl_changed")
  }



public async wybierz_technologie_z_findera() {
    if (!this.lbl) { alert("Problem z lbl"); return; }
    console.log(this.lbl.oferta_tree_finder)
    const lbl1 =  await this.lblSvc.update(this.lbl)
        if (lbl1 && lbl1._id) {
          this.lbl = lbl1
    }
    this.inc("lbl", "wybierz_technologie_z_findera")
 }

  public async pokaż_technologię_handlową() {

    if (!this.lbl?.oferta_tree_finder?._id) { alert("Najpierw przyporządkuj technologię handlową"); return; }
    alert(`/technologie/${this.lbl?.oferta_tree_finder?._id}`)
    window.router.push({ path: `/technologie/${this.lbl?.oferta_tree_finder?._id}` }) 
 }



}
